import { useMutation } from '@tanstack/react-query'

import { requestSyncBankTransactionsToFreeeForAccounting } from '@src/api'
import { DefaultApiRequestSyncBankTransactionsToFreeeForAccountingRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useRequestSyncBankTransactionsToFreeeForAccounting = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiRequestSyncBankTransactionsToFreeeForAccountingRequest
    ) => requestSyncBankTransactionsToFreeeForAccounting(axiosInstance, params),
  })
}
